import { FormControl, FormHelperText, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { Controller, useFormContext } from "react-hook-form";
import { getNumberOfChannelList } from "../pages/app/utils/constants";

export const NumberOfChannelsDropdown = ({ fileType }) => {
  const numberOfChannelsList = getNumberOfChannelList(fileType);
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name="numberOfChannels"
      control={control}
      render={({ field }) => {
        return (
          <FormControl error={!!errors.numberOfChannels} required>
            <InputLabel id="number-of-channels-label">
              Number of Channels
            </InputLabel>
            <Select
              {...field}
              labelId="number-of-channels-label"
              label="Number of Channels"
              value={[0, 1].includes(field.value) ? "" : field.value}
              onChange={(e) => field.onChange(e)}
            >
              {numberOfChannelsList.map(({ value, label }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {errors.numberOfChannels
                ? errors.numberOfChannels.message
                : "Please select the number of channels."}
            </FormHelperText>
          </FormControl>
        );
      }}
    />
  );
};
